<template>
	<div>
		<app-header></app-header>
        <div class="mt-7 ml-7 mr-7 pl-7 pr-7">
            <div class="ml-4 mr-4">
                <v-alert :value="true" color="primary">
                    <div class="ml-4 h3">
                        {{$t("investment.name")}}:<span class="ml-3">{{investmentPeople.name}}</span>
                        <br>
                        {{$t("investment.wallet")}}:<span class="ml-3">{{investmentPeople.walletAddress}}</span>
                    </div>
                </v-alert>
            </div>
            <v-container app-card mt-4>
                <v-flex xs12 lg12>
                    <v-expansion-panel>
                        <v-expansion-panel-content v-for="(investment, index) in investmentList" :key="index">
                            <div slot="header" class="primary--text h4 ml-5">{{index + 1}}. {{investment.investmentId}}</div>
                            <v-card>
                                <v-card-text>
                                    <v-layout row wrap h5>
                                        <v-flex xs1 lg1>
                                        </v-flex>
                                        <v-flex xs3 lg3 fw-bold>
                                            <div class="mt-1">{{$t("investment.transaction")}}</div>
                                            <div class="mt-1">{{$t("investment.sendingAddress")}}</div>
                                            <div class="mt-1">{{$t("investment.purchasingAmount")}}</div>
                                            <div class="mt-1">{{$t("investment.paymentType")}}</div>
                                            <div class="mt-1">{{$t("investment.sentTime")}}</div>
                                            <div class="mt-1">{{$t("investment.recordTime")}}</div>
                                            <div class="mt-1">{{$t("investment.timestamp1")}}</div>
                                            <div class="mt-1">{{$t("investment.timestamp1Price")}}</div>
                                            <div class="mt-1">{{$t("investment.timestamp2")}}</div>
                                            <div class="mt-1">{{$t("investment.timestamp2Price")}}</div>
                                            <div class="mt-1">{{$t("investment.averagePrice")}}</div>
                                            <div class="mt-1">{{$t("investment.purchasingAmountInUSD")}}</div>
                                            <div class="mt-1">{{$t("investment.bonusRate")}}</div>
                                            <div class="mt-1">{{$t("investment.bonus")}}</div>
                                            <div class="mt-1">{{$t("investment.totalIOB")}}</div>
                                        </v-flex>
                                        <v-flex xs8 lg8>
                                            <span class="mt-1">{{investment.transaction}}</span>
                                            <span class="mt-1">{{investment.sendingAddress}}</span>
                                            <span class="mt-1">{{investment.purchasingAmount}}</span>
                                            <span class="mt-1">{{investment.paymentType}}</span>
                                            <span class="mt-1">{{investment.sentTime}}</span>
                                            <span class="mt-1">{{investment.recordTime}}</span>
                                            <span class="mt-1">{{investment.timestamp1}}</span>
                                            <span class="mt-1">{{investment.timestamp1Price}}</span>
                                            <span class="mt-1">{{investment.timestamp2}}</span>
                                            <span class="mt-1">{{investment.timestamp2Price}}</span>
                                            <span class="mt-1">{{investment.averagePrice}}</span>
                                            <span class="mt-1">{{investment.purchasingAmountInUSD}}</span>
                                            <span class="mt-1">{{investment.bonusRate}}</span>
                                            <span class="mt-1">{{investment.bonus}}</span>
                                            <span class="mt-1">{{investment.totalIOB}}</span>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-flex>
            </v-container>
        </div>
	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                userId: this.$store.state.user.id,
                investmentList: [],                 //投资记录集合
                investmentPeople: {},               //投资对象
            }
        },
        computed: {

        },
        created(){
            
        },
        mounted(){
            this.getInvestment();
        },
        watch:{
            
        },        
        methods: {
            //查询和邮箱关联的投资记录
            getInvestment(){
                let investmentUrl=config.baseUrl+'investment/getInvestmentByUserId/'+this.userId;
                this.$http.get(investmentUrl).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.investmentList = data.result;
                        this.investmentPeople = this.investmentList[0];
                        console.log(this.investmentPeople);
                    }else{
                        this.investmentList = [];
                    }
                });
            },
        },

    }
</script>


// WEBPACK FOOTER //
// Investment.vue?74ce9dfc